import { PIPELINE_STAGE_IDS } from "./pipelineStages";

/** Stage-specific primary row action (left button label) */
export const STAGE_PRIMARY_ACTION = {
  [PIPELINE_STAGE_IDS.SHORTLISTED]: "Send invite link",
  [PIPELINE_STAGE_IDS.CONTACTED]: "Follow-up",
  [PIPELINE_STAGE_IDS.NEGOTIATING]: "Negotiate Pricing",
  [PIPELINE_STAGE_IDS.CONTRACTED]: "View contract",
  [PIPELINE_STAGE_IDS.CONFIRMED]: "Performance",
  [PIPELINE_STAGE_IDS.REJECTED]: "Rejected",
};
